<template>
<div>
  <div class="numul">
    <div v-for="(item,index) in drawList" :key="index">
      <img :class="types=='home'?'homeimg':'lotteryimg'" v-if="item" :src="lotteryimg['touzi'+item]" alt />
    </div>
  </div>
  <div class="smalltable" v-if="types=='home'">
    <table cellpadding="0" cellspacing="0" border="0" style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;">
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30" colspan="3">总和</td>
      </tr>
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;" width="140" height="30" v-for="(item,index) in drawingNumbertool" :key="index">{{item}}</td>
      </tr>
    </table>
  </div>
</div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";
import lotteryimg from "@c/lotteryimg";

export default {
  mixins:[lotteryRandBall],
  data() {
    return{
      lotteryimg,
    }
  },
  computed: {
    drawingNumbertool(){
      let tool = [];
      let { drawingNumber } = this;
      if(drawingNumber.length<=1){
        drawingNumber = this.randList;
      }
      let add = drawingNumber.reduce((a,b) => a * 1 + b * 1);
      tool.push(add);
      if (add > 10) { tool.push("大") } else { tool.push("小") };
      if (add %2 == 0) { tool.push("双") } else { tool.push("单") };
      return tool
    }
  }
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  height: 56px;
  .lotteryimg {
    width: 36px;
    line-height: 36px;
    height: 36px;
    margin: 0 8px;
  }
  .homeimg {
    width: 36px;
    line-height: 36px;
    height: 36px;
    margin: 0 5px;
  }
}
</style>